module.exports = __webpack_public_path__ + "img/avatar-s-13.068a2c02.jpg";